import normalizer from '@cordel/helpers/form/schema';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';
// eslint-disable-next-line import/no-extraneous-dependencies
import STATUS_METHODS from '@/helpers/options/status';

import { DATE_FORMAT } from '@cordel/helpers/form/validators/date';

import {
  FILTERS,
  ALWAYS_VISIBLE,
} from './sections';

import {
  SEARCH,
  SELLER_ID,
  STORE_ID,
  BANK_CODE,
  STATUS,
  SORT,
  BEFORE,
  AFTER,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [SEARCH]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'input',
        label: 'Pesquisar',
        labelless: true,
        placeholder: 'Pesquisar...',
        size: 12,
        icon: 'search',
      },
      [STORE_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Loja',
        labelless: true,
        placeholder: 'Filtrar por loja',
        size: 4,
        searchable: 'stores',
      },
      [SELLER_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Vendedor',
        labelless: true,
        placeholder: 'Filtrar por vendedor',
        size: 4,
        searchable: 'sellers',
      },
      [BANK_CODE]: {
        section: FILTERS,
        type: 'select',
        label: 'Banco',
        labelless: true,
        placeholder: 'Filtrar por banco',
        size: 4,
      },
      [STATUS]: {
        section: FILTERS,
        type: 'select',
        label: 'Status',
        labelless: true,
        placeholder: 'Filtrar por status',
        size: 3,
        options: Object.values(STATUS_METHODS),
      },
      [AFTER]: {
        section: FILTERS,
        type: 'input',
        label: 'Data inicial',
        labelless: true,
        placeholder: 'Data inicial',
        mask: {
          format: DATE_FORMAT,
          type: 'patternize',
        },
        size: 3,
      },
      [BEFORE]: {
        section: FILTERS,
        type: 'input',
        label: 'Data final',
        labelless: true,
        placeholder: 'Data final',
        mask: {
          format: DATE_FORMAT,
          type: 'patternize',
        },
        size: 3,
      },
      [SORT]: {
        section: FILTERS,
        type: 'select',
        label: 'Ordenação',
        labelless: true,
        placeholder: 'Ordenação dos resultados',
        size: 3,
        options: Object.values(SORT_METHODS),
        value: SORT_METHODS.created_at_desc.value,
      },
    },
  });
}
